<template>
    <div class="panel panel-default">
        <div class="panel-heading">Add Campaign</div>
        <div class="panel-body">
            <div>
        <div class="alert alert-danger" v-if="formErrors">
            <p><strong>Whoops!</strong> Something went wrong!</p>
            <br>
            <ul>
                <li v-for="error in form.errors">
                    {{ error[0] }}
                </li>
            </ul>
        </div>
        <form class="form-horizontal" role="form" @submit.prevent="addCampaign">

            <!-- Campaign ID -->
            <div class="form-group">
                <label class="col-md-4 control-label">Campaign ID</label>

                <div class="col-md-6">
                    <input type="text" class="form-control" name="campaign_id" v-model="form.campaign_id">
                </div>
            </div>

            <!-- Campaign Name -->
            <div class="form-group">
                <label class="col-md-4 control-label">Campaign Name</label>

                <div class="col-md-6">
                    <input type="text" class="form-control" name="campaign_name" v-model="form.name">
                </div>
            </div>

            <!-- Add Button -->
            <div class="form-group">
                <div class="col-md-offset-4 col-md-6">
                    <button type="submit" class="btn btn-primary" :class="{'btn-loading': loading}" :disabled="loading">
                        Add Campaign
                    </button>
                </div>
            </div>
        </form>
    </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            form: {
                campaign_id: '',
                name: '',
                account_id: '',
                status: 'ENABLED',
                errors: '',
            },
            loading: false,
        }
    },

    computed: {
        ...mapGetters('client',{
            'account': 'activeAdAccount',
        }),

        formErrors() {
            return Object.keys(this.form.errors).length > 0;
        }
    },

    methods: {
        addCampaign() {
            this.loading = true;
            this.form.account_id = this.account.account_id;
            let campaign = this.form;
            this.$store.dispatch('client/addCampaign', {
                    campaign: campaign,
                }).then(response => {
                    Bus.$emit('show-success-alert', 'Success! The campaign has been added');
                    Bus.$emit('reload-campaign-list');
                    this.reset();
                })
                .catch(response => {
                    if (response.status !== 422) {
                        Bus.$emit('show-error-alert', response.data.message);
                    } else {
                        this.form.errors = response.data.errors;
                    }
                    this.loading = false;
                });
        },

        reset() {
            Object.assign(this.$data, this.$options.data());
        }
    },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/clients/NewCampaignForm.vue